function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M-1305-398H615V622h-1920z"
}), React.createElement("path", {
  fill: "#",
  d: "M-1305-167H615v789h-1920z"
}), React.createElement("g", {
  transform: "translate(-70 -136)"
}, React.createElement("path", {
  d: "M103.527 188.611a3.393 3.393 0 1 1 0 6.786 3.393 3.393 0 0 1 0-6.786zm0 1.697a1.696 1.696 0 1 0 0 3.393 1.696 1.696 0 0 0 0-3.393zm-20.942-1.363 13.257 2.204-.348 2.096-13.258-2.203.349-2.097zm36.567-7.973 1.571 1.43-9.605 10.549-1.571-1.43 9.605-10.549zm6.027 5.121a3.393 3.393 0 1 1 0 6.786 3.393 3.393 0 0 1 0-6.786zm0 1.697a1.696 1.696 0 1 0 0 3.393 1.696 1.696 0 0 0 0-3.393zm-26.035-19.5 1.74 1.22-11.952 17.038-1.74-1.22 11.952-17.037zm1.839 10.143a3.393 3.393 0 1 1 0 6.786 3.393 3.393 0 0 1 0-6.786zm0 1.696a1.696 1.696 0 1 0 0 3.393 1.696 1.696 0 0 0 0-3.393zm13.571-6.786a3.393 3.393 0 1 1 0 6.786 3.393 3.393 0 0 1 0-6.786zm0 1.697a1.696 1.696 0 1 0 0 3.393 1.696 1.696 0 0 0 0-3.393zm-30.536-4.241a3.393 3.393 0 1 1 0 6.785 3.393 3.393 0 0 1 0-6.785zm0 1.696a1.696 1.696 0 1 0 0 3.393 1.696 1.696 0 0 0 0-3.393zm34.777-9.33a3.393 3.393 0 1 1 0 6.785 3.393 3.393 0 0 1 0-6.786zm-20.31-17.094 13.592 22.262-1.814 1.108-13.592-22.262 1.814-1.108zm20.31 18.79a1.696 1.696 0 1 0 0 3.393 1.696 1.696 0 0 0 0-3.393zm-22.902-5.09a3.393 3.393 0 1 1 0 6.786 3.393 3.393 0 0 1 0-6.785zM91.345 143l1.935.877-9.605 21.173-1.935-.877 9.605-21.173zm4.548 18.469a1.696 1.696 0 1 0 0 3.393 1.696 1.696 0 0 0 0-3.393zm27.287-14.116 2.015.671-4.25 12.75-2.015-.671 4.25-12.75zm-6.93.544a3.393 3.393 0 1 1 0 6.786 3.393 3.393 0 0 1 0-6.786zm0 1.697a1.696 1.696 0 1 0 0 3.393 1.696 1.696 0 0 0 0-3.393z",
  fill: "currentColor"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 68,
    height: 68
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/pasza_wloknista.5b36d2d4.svg";
export { SvgComponent as ReactComponent };